import React, { ReactNode } from 'react';
import {
    DayMonthPicker,
    DayMonthPickerProps,
    FlexyFormLabel,
    FlexyFormTooltipProps,
} from '@europrocurement/flexy-components';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { FormHelperText, SxProps } from '@mui/material';

export type ControlledDayMonthPickerProps = {
    name: string;
    rules?: RegisterOptions;
    label?: string;
    inputlabel?: string | ReactNode;
    required?: boolean;
    sx?: SxProps;
    tooltip?: FlexyFormTooltipProps;
} & Omit<DayMonthPickerProps, 'onChange' | 'items'>;

const ControlledDayMonthPicker: React.FunctionComponent<ControlledDayMonthPickerProps> = function ({
    name,
    rules,
    inputlabel,
    required,
    sx: sxProps,
    tooltip,
    ...inputProps
}) {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <>
                    {inputlabel && inputlabel !== '' ? (
                        <FlexyFormLabel
                            required={required}
                            sx={sxProps}
                            data-testid="test-id-FlexyInput-label"
                            tooltip={tooltip}
                        >
                            {inputlabel}
                        </FlexyFormLabel>
                    ) : null}

                    <DayMonthPicker
                        {...inputProps}
                        value={value}
                        onChange={onChange}
                    />

                    {error ? (
                        <FormHelperText
                            sx={{
                                margin: '4px 14px 0px 14px',
                            }}
                            error
                        >
                            {error?.message}
                        </FormHelperText>
                    ) : null}
                </>
            )}
        />
    );
};

export default ControlledDayMonthPicker;
